export const ADD_LEARNER_CARD = 'ADD_LEARNER'
export const EDIT_LEARNER_CARD = 'EDIT_LEARNER_CARD'
export const EDIT_LEARNER_ROW = 'EDIT_LEARNER_ROW'
export const ADD_LEARNER_ROW = 'ADD_LEARNER_ROW'
